import _replace from "ramda/es/replace";
import _map from "ramda/es/map";
import _match from "ramda/es/match";
import _pipe from "ramda/es/pipe";
import _curry from "ramda/es/curry";
export default _curry(function (start, end, string) {
  return _pipe(_match(new RegExp("".concat(start, "([^").concat(start).concat(end, "]+)").concat(end), 'gm')), _map(_replace(new RegExp("".concat(start, "|").concat(end), 'g'), '')))(string);
});